/* eslint-disable no-unused-vars */
import React from "react";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";
const MapProps = {
  require:true
}
export const FormLabel = (props ) => {
  return props.label && (
    <Form.Label className={props?.className}>
      {props.label}
      {props?.require !== false &&  <span className="text-danger">{" "} *</span>}
    </Form.Label>
  )
}

export const FormControl = (props) => {
    return (
      <>
      <Form.Control
       as={props?.as}
       rows={props?.rows}
       placeholder={props?.placeholder}
       value={
         props?.value
       }
       name={props?.name}
       onChange={props?.onChange}
       type={props?.type}
       onWheel={(e) => e.target.blur()}
       style={props?.style}
       disabled={props?.disabled}
     />
     <span className="text-danger">{props?.error}</span>
     </>
    )
}
function FormgroupPage (props) {
     return (
        <Form.Group className={`common_form ${props?.className}`}>
          <FormLabel {...props} />
          <FormControl {...props}/>
          {/* <span className="text-danger">{props?.error}</span> */}
        </Form.Group>
     )
}
FormgroupPage.propTypes = {
  require: PropTypes.any
}
FormgroupPage.defaultProps = {
  require:true
}
export default FormgroupPage;